import React, { useEffect, useState } from 'react';
import CarouselWidget from '../../components/CarouselWidget/CarouselWidget';
import ProductSpecificationWidget from '../../components/ProductSpecificationWidget/ProductSpecificationWidget';
import { Container, Row, Col, Button } from 'react-bootstrap';
import GroupTechCardWidget from '../../components/GroupTechCardWidget/GroupTechCardWidget';
import ProductBadgeWidget from '../../components/ProductBadgeWidget/ProductBadgeWidget';
import CarouselImageWidget from '../../components/CarouselImageWidget/CarouselImageWidget';
import ProductMediaWidget from '../../components/ProductMediaWidget/ProductMediaWidget';
import ProductOverView from '../../components/ProductOverView/ProductOverView';
import ProductFeatureWidget from '../../components/productFeatureWidget/productFeatureWidget';
import ProductDetailWidget from '../../components/ProductDetailWidget/ProductDetailWidget';
import ProductsReviewWidget from '../../components/ProductsReviewWidget/ProductsReviewWidget';
import MilitaryDiscount from '../../components/MilitaryDiscount/MilitaryDiscount';
// import ModelViewerWidget from '../../components/ModelViewerWidget/ModelViewerWidget'
import ProductTestimonialsWidget from '../../components/ProductTestimonialsWidget/ProductTestimonialsWidget';
import httpService from '../../services/httpService';
import FooterComp from '../../components/Footer/Footer';
import HeaderComp from '../../components/Header/Header';
import ProductDetails from '../../components/ProductDetails/ProductDetails';
import config from '../../config/config';
import appService from '../../services/appService';
import { connect } from 'react-redux';
import SetHeaders from '../../config/SetHeaders';
import { eventAddToCart } from '../../helpers/events';
import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import axios from 'axios';
import dynamic from 'next/dynamic';
import ExtendAsProductNotFound from '../../components/ExtendWarrantyCart/extendAsProductNotFound';

const ProductContainer = ({
  history,
  match,
  onToggle,
  setCartItems,
  showLoader,
  hideLoader,
  showProcessing,
  hideProcessing,
  Header,
  Body,
  Footer,
  response
}: any) => {

  // Model Viewer has to be imported Dynamically 
  const DynamicModel = dynamic(
    () => import('../../components/ModelViewerWidget/ModelViewerWidget'),
    {ssr: false}
  )
  // A new state is introduced which will store the product id of extend warranty
  const [extendWarrantyId,setExtendWarrantyId] = useState(undefined);
 
  match = useRouter()
  const addToCart = (id: number, plan?: any) => {
    const cartid = appService.getKey('cartid');
    showProcessing();
    httpService.invokeApi(
      {
        url: `${config.endpoints.getCart}/${cartid}/cartitems`,
        method: 'put',
        data: {
          productId: id,
          quantity: 1
        }
      },
      (success: boolean, res: any) => {
        // While adding the product to the cart, we will check if there is any extend warranty plan involved
        if (success && res.id && plan) {
          httpService.invokeApi(
            {
              url: `${config.endpoints.getCart}/${cartid}/cartitems`,
              method: 'put',
              data: {
                  productId: extendWarrantyId,
                  associatedProductId: id,
                  quantity: 1,
                  planId: plan.planId,
                  price: plan.price/100,
                  duration: plan.term
              }
            },
            (success: boolean, res: any) => {
            if (success && res.id) {
              const request: any = { method: 'get', url: config.endpoints.getCart };
              if (cartid) {
                request.headers = { cartid: cartid };
              }
              httpService.invokeApi(request, (success: boolean, resp: any) => {
                if (success && resp.cartId) {
                  appService.setKey('cartid', resp.cartId);
                  setCartItems(resp);
                  onToggle();
                  hideProcessing();
                } else {
                  hideProcessing();
                }
              });
            } else {
              hideProcessing();
            }
            }
          )       
        } else if (success && res.id && !plan) {
            const request: any = { method: 'get', url: config.endpoints.getCart };
            if (cartid) {
              request.headers = { cartid: cartid };
            }
            httpService.invokeApi(request, (success: boolean, resp: any) => {
              if (success && resp.cartId) {
                appService.setKey('cartid', resp.cartId);
                setCartItems(resp);
                onToggle();
                hideProcessing();
              } else {
                hideProcessing();
              }
            });
        } else {
          hideProcessing();
        }
      }
    );
  };
  
  const GoogleAnalyticsAddToCart = (item: any) => {
    let product = {};
    if (item.product_categories && item.product_categories.length > 0) {
      let category = '';
      item.product_categories.forEach((element: any, i: number) => {
        if (element.name) {
          category += element.name;
          if (i < item.product_categories.length) {
            category += '/';
          }
        }
      });
      product = { ...product, category: category };
    }
    product = {
      ...product,
      id: item.id,
      name: item.displayTitle ? item.displayTitle : item.title,
      discount: item.newPrice !== null ? item.price - item.newPrice : 0,
      affiliation: 'Nexersys Store',
      brand: 'Nexersys',
      // item_category: 'pants',
      // item_variant: 'black',
      price: item.newPrice !== null ? item.newPrice : item.price,
      currency: item.currency ? item.currency.code : 'USD',
      quantity: 1
    };
    const data = {
      currency: 'USD',
      items: [product],
      value: item.newPrice !== null ? item.newPrice : item.price
    };
    eventAddToCart(data);
  };

  // In the below useEffect, we have requested product ID of Extend Warranty
  useEffect(()=>{
    showLoader()
    httpService.invokeApi(
      {
        url: `${config.endpoints.getExtendWarrantyType}?productType=Warranty&title=Extended Warranty`,
        method: 'get',
      }
      ,
      (success: boolean, res: any) => {
        if(success) {
          setExtendWarrantyId(res[0].id);
          hideLoader();
        } else {
          hideLoader();
        }
      }
    );
    
},[]);

  const handleSubmit = () => {
    //@ts-ignore
    const component = window.Extend.buttons.instance(`#extend-product-${Body.id}`);
    const plan = component.getPlanSelection();
    // If there is any selected plan then we will pass the plan as an argument
    if(plan) {
      addToCart(Body.id, plan);
    } else {
      addToCart(Body.id);
    }
    GoogleAnalyticsAddToCart(Body);
  }

  return (
    <React.Fragment>
      {response && !response.Seo && (
        <Head>
          <title>{response.displayTitle ? response.displayTitle : response.title} - Nexersys</title>
        </Head>
      )}
      {response && <SetHeaders HEADERS={response} />}
      {Header && <HeaderComp HeaderValue={Header} />}
      <div className="app-body">
        {Body &&
          Body.title !== "Extended Warranty" &&
          Body.template &&
          Body.template.Body &&
          Body.template.Body.map((item: any, i: any) => {
            switch (item.__component) {
              case 'product-details.product-overview-widget':
                return <ProductOverView key={i} data={Body} template={item} handleSubmit={handleSubmit} prodName={response.title} extendWarrantyId={extendWarrantyId} />;
              case 'product.review-widget':
                return <ProductsReviewWidget key={i} data={item.ReviewDetails} template={item} />;
              case 'mini-widget.product-testimonials':
                return <ProductTestimonialsWidget key={i} data={item} template={item} />
              case 'product.product-key-features-widget':
                return <ProductFeatureWidget key={i} data={Body.ProductKeyFeatures} />;
              case 'product-details.product-media-widget':
                return <ProductMediaWidget key={i} data={Body.ProductMedia} template={item} />;
              case 'product-details.group-tech-card-widget':
                return <GroupTechCardWidget key={i} data={item.GroupTechInfo} />;
              case 'product-details.product-badge-widget':
                return <ProductBadgeWidget key={i} popup={true} data={Body.AdditionalInfo} />;
              case 'product-details.carousel-image-widget':
                return <CarouselImageWidget key={i} data={Body.ProductInfoSlider} />;
              case 'product.product-detail-widget':
                return <ProductDetailWidget key={i} data={Body} template={item} />;
              case 'product-details.product-specification-widget':
                let proSpec = [];
                proSpec = item.SpecificationKeys.map((item: any) => {
                  return Body[item.name];
                });
                return (
                  proSpec && (
                    <Container key={i} className="feature-carousel-container">
                      <Row lg="2" sm="1" xs="1">
                        <Col sm={{ order: item.specificationTableAlignment === 'left' ? 1 : 2 }}>
                          <ProductSpecificationWidget data={proSpec} />
                        </Col>
                        <Col sm={{ order: item.carousalAlignment === 'right' ? 2 : 1 }}>
                          <CarouselWidget data={Body[item.ImagesKey.name]} />
                        </Col>
                      </Row>
                    </Container>
                  )
                );
              case 'product.single-product-widget':
                return <ProductDetails key={i} template={item} data={Body} />;
              case 'product-details.button-widget':
                return (
                  <div className="shop-now-btn-component" key={i}>
                    {item.buttonLink ? (
                      <Link href={item.buttonLink} >
                        <a className="button-show-now">{item.buttonLabel}</a>
                      </Link>
                    ) : (
                      <Button
                        variant="danger"
                        onClick={() => {
                          addToCart(Body.id);
                          GoogleAnalyticsAddToCart(Body);
                        }}
                        className="button-show-now"
                      >
                        {item.buttonLabel}
                      </Button>
                    )}
                  </div>
                );

              default:
                return null;
            }
          })}
      </div>
      {Body && Body.title === "Extended Warranty" && (
        <ExtendAsProductNotFound/>
      )} 
      {Footer && <FooterComp data={Footer.Footer} />}
    </React.Fragment>
  );
};

const mapState = (state: any) => {
  return {
    status: state.cartStatus,
    cart: state.cart
  };
};

const mapDispatch = (dispatch: any) => {
  return {
    onToggle: () => dispatch({ type: 'TOGGLE_CART' }),
    setCartItems: (cartItems: any) => {
      dispatch({ type: 'ON_CART_LOAD', payload: cartItems });
    },
    showLoader: () => dispatch({ type: 'LOADER_SHOW', isLoadingPage: true }),
    hideLoader: () => dispatch({ type: 'LOADER_HIDE' }),
    showProcessing: () => dispatch({ type: 'LOADER_SHOW' }),
    hideProcessing: () => dispatch({ type: 'LOADER_HIDE' })
  };
};

export async function getStaticProps({ params }) {
  const { data } = await axios.get(config.endpoints.products, { params: { slug: params.key } })
  return {
    props: {
      Header: data.template.Header,
      Body: data,
      Footer: data.template.Footer,
      response: data
    },
    revalidate: 3600
  }
}

export async function getStaticPaths() {
  const { data } = await axios.get(config.endpoints.products)
  const paths = data.map((item => ({
    params: { key: item.slug }
  })
  ))
  return {
    paths, fallback: false
  }
}


export default connect(
  mapState,
  mapDispatch
)(ProductContainer);
